import { render, staticRenderFns } from "./EducationalRatingForm.vue?vue&type=template&id=f0b02a62&"
import script from "./EducationalRatingForm.vue?vue&type=script&lang=js&"
export * from "./EducationalRatingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports